import React, {useState, useEffect, useRef} from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import Papa from "papaparse";
import {Button, Layout, Modal, Radio,Spin, Input} from "antd";
import {getPopupSizeOption} from '../Common/util';
import {useWindowCloseMsg} from '../Common/windowCloseMsg';
import {resultColumnData} from './columns';
import {getProcessingPage, getFindReportIdInfo, getFindAnalysisResultList, postSaveResultUpload, postSaveResultAnalysis, postModifyVaResultData, postAnalysisDelete, postSaveResultAutoSelf,getFindInfoMeasureListData } from '../../pages/Common/api';
import AnalysisTable from './AnalysisTable.js';
import { CSVLink } from "react-csv";
import * as XLSX from 'xlsx';
import SelectBox from '../Common/SelectBox';
import { analySelectOptions } from '../Common/options.js';
import AnalysisHtmx from './AnalysisHtmx.js';
import { exportDbDetailReport } from './exportDbDetailReport.js';
import { getCodeName } from '../Common/CodeSelect.js';
import 'htmx.org'; // 설치되어 있어야 함 (npm install htmx.org)

const { Content } = Layout;

/** -------------------------------------------------------------------------- **/
function AnalysisResultPop() {
    const params = useParams();
    const selfFlagRef = useRef(false);
    const csvLinkRef = useRef(null);
    // 변수 선언
    
    const reportId = params.reportId;
    // const [reportId, setReportId] = useState(params.reportId);
    const [csvReadyDownload, setCsvReadyDownload] = useState(false);
    const [csvDownLoading, setCsvDownLoading] = useState(false);
    const [detailReportLoading, setDetailReportLoading] = useState(false);
    const [companyCode, setCompanyCode] = useState('');
    const [assetType, setAssetType] = useState('');
    const [reportName, setReportName] = useState('');
    const [reportInfo, setReportInfo] = useState({});
    const [resultType, setResultType] = useState(params.resultType);
    const [resultListData, setResultListData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [dataDeleting, setDataDeleting] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    const [spinflag, setSpinflag] = useState(true);
    const [selfAutoFlag, setSelfAutoFlag] = useState(true); // self 자동화 플래그
    const [resultListAssetcd, setResultListAssetcd] = useState("");
    const [resMessage, setResMessage] = useState("");
    const [parsedData, setParsedData] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [values, setValues] = useState([]);
    const [timeoutCount,setTimeoutCount] = useState(800);

    // 진단결과 수정을 위한 조회조건
    const [assetCd, setAssetCd] = useState('');
    const [measureCd, setMeasureCd] = useState('');
    const [resultCd, setResultCd] = useState('');
    const [spinflagMain,  setSpinflagMain] = useState(false);
    const [csvHeader, setCsvHeader] = useState([]);
    const [csvData, setCsvData] = useState([]);

    // 페이지 설정
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(200);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPage, setTotalPage] = useState(1);
    const [basePageSizeOptions, setBasePageSizeOptions] = useState(['20', '50', '100', '200']);

    // 확정여부
    const confirmed = reportInfo.confirm=='Y'?true:false;   
    const loadDefaultMessage = "Loading...";
    const [loadMessage, setLoadMessage] = useState(loadDefaultMessage);

    // 데이터 수정 카운트
    const [currentModCount, setCurrentModCount] = useState(0);

    // Table 선택박스 설정
    const [selectedRowKeys, setSelectedRowKeys] = useState([]); 
    const titleName = (resultType == 'C') ? '최초분석' : '이행점검';
    const [pageOnStart, setPageOnStart ] = useState(true);

    // 진단결과-조회조건
    const resultCdSelectOptions = JSON.parse(localStorage.getItem('code_list')).filter(item => item.type == 'result_cd');
    resultCdSelectOptions.push({text: '확인필요', value: 'SELF'})
    let popupCheckTimer = null; 

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    // 샘플 파일 데이터 작성 
    const templateColumn = () => {
        // 보고서ID 필수조건 체크
        if (reportId == '') {
            Modal.info({title:"샘플용 진단항목 리스트", content:"Report ID가 누락되었습니다."});
            return;
        }
        
        setCsvDownLoading(true);
        const assetHeaders = [
            { label: "asset_cd", key: "asset_cd" }, 
            { label: "asset_nm", key: "asset_nm" }, 
            { label: "asset_ip", key: "asset_ip" }
        ];

        const getRandomValue = () => {
            // const values = ["Y", "N", "SELF"];
            // const randomIndex = Math.floor(Math.random() * values.length);
            // return values[randomIndex];

            const random = Math.random();
            if (random < 0.7) {       // 70% 확률로 Y
                return "Y";
            } else if (random < 0.9) { // 20% 확률로 N
                return "N";
            } else {                  // 10% 확률로 SELF
                return "SELF";
            }
        };

        function escapeCSVValue(value) {
            if (value == null) return '';
            const str = String(value);
            // const needsQuotes = /[",\r\n]/.test(str);  // 감싸야 하는 조건
            const escaped = str.replace(/"/g, '""');   // 따옴표 이스케이프
            return escaped;
            // return needsQuotes ? `"${escaped}"` : escaped;
        }
        
        // 데이터 없을 때 샘플파일 /////////////////////////////////////////////////////////////////
        const url = getFindAnalysisResultList(reportId, resultType, assetCd, measureCd, resultCd, 1, 999999999);
        axios.get(url)
            .then(async (response) => {
                // 데이타 핸들링을 위하여 Key값 추가 
                const resData = response.data.data
                const resDataCount = resData.length;

                if(resDataCount > 0){
                    const measureCodeSet = new Set();
                    const csvHeaderData = [...assetHeaders];
                    const csvHeaderTailData = [];
                    
                    for(let i=0; i < resDataCount; i++){
                        measureCodeSet.add(resData[i].measure_cd);
                    }
                    
                    const measureCodeArray = Array.from(measureCodeSet);

                    for (let i = 0; i < measureCodeArray.length; i++) {
                        const measureCode = measureCodeArray[i];
                        csvHeaderData.push({ label: `${measureCode}-R`, key: `${measureCode}-R` });
                        csvHeaderTailData.push({ label: `${measureCode}-SA`, key: `${measureCode}-SA` });
                    }

                    const csvDataResult = {};
                    for (let i = 0; i < resData.length; i++) {
                        const item = resData[i];
                        const assetCode = item.asset_cd;
                        
                        if (!csvDataResult[assetCode]) {
                            csvDataResult[assetCode] = {
                                asset_cd: item.asset_cd,
                                asset_nm: item.asset_nm,
                                asset_ip: item.asset_ip,
                            };
                        }
                        
                        csvDataResult[assetCode][`${item.measure_cd}-R`] = item.result_cd;

                        console.log(item.asset_nm, item.measure_cd, item.result_desc);
                        csvDataResult[assetCode][`${item.measure_cd}-SA`] = escapeCSVValue(item.result_desc);
                        console.log(csvDataResult[assetCode][`${item.measure_cd}-SA`] );
                    }

                    const transformedData = [];
                    const assetCodes = Object.keys(csvDataResult);
                    
                    for (let i = 0; i < assetCodes.length; i++) {
                        const assetCode = assetCodes[i];
                        transformedData.push(csvDataResult[assetCode]);
                    }

                    setCsvHeader([...csvHeaderData, ...csvHeaderTailData]);
                    setCsvData(transformedData);
                    setCsvReadyDownload(true);
                    return null;
                }else{
                    // 데이터 없을 때 샘플파일 /////////////////////////////////////////////////////////////////
                    return await axios.get(getFindInfoMeasureListData(reportId));
                }
            })
            .then(async (response2)=>{
                if(response2!==null){
                    const rHeaders = response2.data.map((data) => {
                        return { label: data.measure_cd+"-R", key: data.measure_cd+"-R" };
                    });
                    
                    const saHeaders = response2.data.map((data) => {
                        return { label: data.measure_cd+"-SA", key: data.measure_cd+"-SA" };
                    });
                    
                    const csv_headers = [...assetHeaders, ...rHeaders, ...saHeaders];
                    setCsvHeader(csv_headers);

                    const csv_data=response2.data.reduce((acc, data) => {
                        acc[data.measure_cd+"-R"] = getRandomValue();
                        acc[data.measure_cd+"-SA"] = "■ 현황:...";
                        return acc;
                    }, {});
                    
                    setCsvData([{asset_cd:"자산코드",asset_nm:"자산이름",asset_ip:"IP주소", ...csv_data}]);
                    setCsvReadyDownload(true);   
                }

            })
            .catch((error) => { 
                setSelfAutoFlag(true);
                setSpinflag(false);
                setCsvDownLoading(false);
                console.log(error);
                Modal.error({title:titleName, content:error.message});
            })
            .finally(() => {
                setTimeout(() => {
                    setSpinflag(false);
                    setCsvDownLoading(false);
                }, 
                timeoutCount)});
    };
    
    // 상세결과 보고서(엑셀) 다운로드 - 템플릿 양식에 API 데이터를 채워 출력
    const onClickDetailReportHandler = async () => {
        if (reportId == '' || resultType == '') {
            Modal.info({ title: titleName, content: "Report Id, Result Type이 누락되었습니다." });
            return;
        }
        setDetailReportLoading(true);
        try {
            // 표지 치환값 계산
            const now = new Date();
            const companyName = (reportInfo.com_cd ? getCodeName('com_cd', reportInfo.com_cd) : '')
                || reportInfo.com_nm || '';
            const diagType = (assetType ? getCodeName('asset_type', assetType) : '') || assetType || '';
            // 날짜: 항상 오늘 날짜(YYYY.MM)
            const diagDate = `${now.getFullYear()}.${String(now.getMonth() + 1).padStart(2, '0')}`;

            await exportDbDetailReport({
                reportId,
                resultType,
                reportName,
                companyName, // com_cd 치환
                diagType,    // asset_type 치환
                diagDate,    // year.month 치환 (YYYY.MM)
            });
        } catch (error) {
            console.error('상세결과 보고서 생성 실패:', error);
            Modal.error({ title: titleName, content: error.message || '상세결과 보고서 생성에 실패했습니다.', okText: "Close" });
        } finally {
            setDetailReportLoading(false);
        }
    };

    // 기존에 사용하던 샘플자산 데이터(현재 자동등록)
    // const csv_headers = [
    //     { label: "자산코드", key: "asset_cd" },
    //     { label: "자산이름", key: "asset_nm" },
    //     { label: "IP주소", key: "asset_ip" },
    //     { label: "진단항목(체크)", key: "LX1_01_R" },
    //     { label: " ", key: "LX1_02_R" },
    //     { label: " ", key: "LX1_03_R" },
    //     { label: " ", key: "LX1_04_R" },
    //     { label: " ", key: "LX1_05_R" },
    //     { label: "진단항목(내용)", key: "LX1_01_SA" },
    //     { label: " ", key: "LX1_02_SA" },
    //     { label: " ", key: "LX1_03_SA" },
    //     { label: " ", key: "LX1_04_SA" },
    //     { label: " ", key: "LX1_05_SA" },
    // ];
      
    // const csv_data = [
    //     { asset_cd: "asset_cd", asset_nm: "asset_nm", asset_ip: "asset_ip", LX1_01_R: "LX1_01_R", LX1_02_R: "LX1_02_R", LX1_03_R: "LX1_03_R", LX1_04_R: "LX1_04_R", LX1_05_R: "추가항목...", LX1_01_SA: "LX1_01_SA", LX1_02_SA: "LX1_02_SA", LX1_03_SA: "LX1_03_SA", LX1_04_SA: "LX1_04_SA",LX1_05_SA: "추가항목..."},
    //     { asset_cd: "LX001",  asset_nm: "isecure web01", asset_ip: "251.12.12.56", LX1_01_R: "Y", LX1_02_R: "N", LX1_03_R: "SELF", LX1_04_R: "Y", LX1_05_R: "추가결과...", LX1_01_SA: "■ 현황---", LX1_02_SA: "■ 현황---", LX1_03_SA: "■ 현황---", LX1_04_SA: "■ 현황---", LX1_05_SA: "추가결과..."},
    //     { asset_cd: "" },
    //     { asset_cd: "" },
    //     { asset_cd: "■ 첫 줄은 반드시 삭제해야 합니다." },
    //     { asset_cd: "■ 자산유형에 따라 진단항목 코드(LX1_01, DB1_01, WS1-01,...)는 달라지므로 취약점분석기준의 진단항목코드를 확인해주세요." },
    //     { asset_cd: "■ 추가항목은 LX1_05_R, LX1_06_R, ... 처럼 적어 주시면 됩니다." },
    //     { asset_cd: "■ 진단결과는 필수값으로 Y/N/SELF 중에서 입력해주세요." },
    //     { asset_cd: "■ LX1_01_R(체크) : 진단항목에 대한 진단여부(Y/N/SELF) 기입" },
    //     { asset_cd: "■ LX1_01_SA(내용) : 진단항목에 대한 진단내용(■현황:---) 기입" },
    // ];


    const sampleColumnMake = () => {
        //자동조회
        if(reportId) {
            let count=0;
            axios.get(getFindInfoMeasureListData(reportId))
                .then((response) => {
                    count=response.request.responseText.length;
                    setReportInfo(response.data[0]);
                    setCompanyCode(response.data[0].com_cd);
                    setAssetType(response.data[0].asset_type);
                    setReportName(response.data[0].report_nm);
                    setReportId(response.data[0].report_id);
                })
                .catch((error) =>  Modal.error({title:titleName, content:error.message}))
                .finally(() => setTimeout(() => setSpinflag(false), 800));
        }
    }

    //----------------------------------------------------------------------------------------
    // 레포트 조회
    const findAnalysisInfo = () => {
        //자동조회
        if(reportId) {
            let count=0;
            axios.get(getFindReportIdInfo(reportId))
                .then((response) => {
                    count=response.request.responseText.length;
                    setReportInfo(response.data[0]);
                    setCompanyCode(response.data[0].com_cd);
                    setAssetType(response.data[0].asset_type);
                    setReportName(response.data[0].report_nm);
                    // setReportId(response.data[0].report_id);
                    
                    setTimeoutCount(timeoutCount * (response.request.responseText.length/1000));
                })
                .catch(
                    (error) => {
                        setSpinflag(false);
                        Modal.error({title:titleName, content:error.message});
                    }
                );
                // .finally(() => setTimeout(() => setSpinflag(false), timeoutCount));
        }
    }

    // 결과 조회
    const findAnalysisResultList = (nowPage, nowPageSize) => {

        setShowUpload(false);
        setSpinflag(true);
         // 선택정보 초기화
        setSelectedRowKeys([]);
        if(reportId && resultType) {
            // try{
            //     const res = await axios.get(getFindAnalysisResultList(reportId, resultType, assetCd, measureCd, resultCd));
            //     // 데이타 핸들링을 위하여 Key값 추가
            //     const updateList = res.data.map((data) => ({
            //         ...data,
            //         key: data.id,
            //     }));
            //     setResultListData(updateList);
            // }catch(error){
            //     console.log("AnalysisResult.js --- 130 error");
            //     console.dir(error);
            // }
            
            const url = getFindAnalysisResultList(reportId, resultType, assetCd, measureCd, resultCd, nowPage, nowPageSize);
            axios.get(url)
                .then((response) => {
                    // 데이타 핸들링을 위하여 Key값 추가 
                    const resData = response.data
                    // setPageSize(resDataAssetPageSize);
                    if (pageOnStart) {
                        const assetListLength = resData.asset_list ? resData.asset_list.length : 0;
                        console.log("assetListLength", assetListLength);

                        if (assetListLength > 0) {                            
                            const resDataAssetPageSize = Math.round(resData.total_count / assetListLength);
                            console.log("resDataAssetPageSize", resDataAssetPageSize);
                            setBasePageSizeOptions([String(resDataAssetPageSize), ...basePageSizeOptions]);
                            console.log("basePageSizeOptions", basePageSizeOptions);
                            setPageSize(resDataAssetPageSize);
                        }
                    }

                    let filteredData = resData.data.filter(data => data.measure_nm != null);
                    
                    // 클라이언트 사이드 필터링 추가 (백엔드 필터링이 제대로 작동하지 않는 경우)
                    if (resultCd) {
                        filteredData = filteredData.filter(data => data.result_cd === resultCd);
                    }
                    
                    const updateList = filteredData.map((data) => (
                        {...data, key: data.id}
                    ));
                    
                    // const updateAssetCd = resData.data.filter(data => data.measure_nm == null).map((data) => (
                    //     data.asset_cd
                    // ));
                    const updateAssetCd = resData.asset_list.join();
                    
                    setPage(resData.current_page);
                    setTotalCount(resData.total_count);
                    setTotalPage(resData.total_page);
                    setResultListData(updateList);
                    

                    if(updateAssetCd == "" || updateAssetCd == null){
                        setResultListAssetcd("default");
                    }else{
                        setResultListAssetcd(updateAssetCd);
                    }
                    
                    if (window.opener && window.opener.onHandleDataChange) {
                        window.opener.onHandleDataChange();
                    }

                    if(resData.data.length < 1 && resultCd==="") setSelfAutoFlag(false);
                    setPageOnStart(false);
                })
                .catch((error) => { 
                    setSelfAutoFlag(true);
                    setSpinflag(false);
                    Modal.error({title:titleName, content:error.message});
                })
                .finally(() => setTimeout(() => setSpinflag(false), timeoutCount));
        }
    }

    // 파일업로드
    const onChangeUploadHandler = (event) => {
        setShowUpload(true);
        setIsDataChange(false);
        
        // Passing file data (event.target.files[0]) to parse using Papa.parse
        if(event.target.files[0]){

            // setSelfFlag((prevSelfFlag)=>{ return false; });
            Papa.parse(event.target.files[0], {
                header: true,
                skipEmptyLines: 'greedy',
                complete: (results) => {
                    const rowsArray = [];
                    const valuesArray = [];
                    // const keyRegex = /^(Y|N|P|NA|SELF)$/;
                    const keyRegex = /.+-R$/i;
                    let keyNameCount=0;
                    let keyNameOrgCount=0;
                    let keyName = "";
                    let keyBreak=true; // selfFlag로 확인하면 파일 2번째 업로드시 적용이 안되는 부작용이 있어 별도 로컬변수 사용 

                    // 오브젝트값이 배열로 들어온다. [ {키1:값1, 키2:값2}, {키1:값1, 키2:값2}, {키1:값1, 키2:값2} ]
                    results.data.map((d) => {
                        let i=0;

                        // 헤더 필드가 필요하기 때문에 한번만 실행하면 됨  [ {키1:값1, 키2:값2 } , 뒤는 필요없음 ]
                        if(keyNameCount===0){
                            // 키1, 키2 을 배열로 가져옴 
                            keyName = Object.keys(d);
                            keyNameCount = keyName.length;
                            rowsArray.push(keyName);

                        }

                        for(i=0; keyNameCount>i; i++){
                            if( !keyRegex.test(d[keyName[i]]) ){
                                if(d[keyName[i]] =="N/A"){
                                    d[keyName[i]]="NA";
                                }
                            }
                        }
                        // if(keyNameCount===0){
                        //     // 키1, 키2 을 배열로 가져옴 
                        //     keyName = Object.keys(d);
                        //     keyNameCount = keyName.length;

                        //     // asset_cd,name,ip 제외하고 값부분만 가져옴(현황도 제외)  
                        //     keyNameOrgCount = keyNameCount-((keyNameCount-3)/2);
                        //     rowsArray.push(keyName);
                        // }

                        // for(i=3; keyNameOrgCount>i; i++){
                        //     d[keyName[i]]=d[keyName[i]].toUpperCase();
                            
                        //     if( !keyRegex.test(d[keyName[i]]) ){
                        //         if(d[keyName[i]] =="N/A"){
                        //             d[keyName[i]]="NA";
                        //         }
                        //     }
                        // }

                        valuesArray.push(Object.values(d));
                    });
                    
                    // Parsed Data Response in array format
                    setParsedData(results.data);

                    // Filtered Column Names
                    setTableRows(rowsArray[0]);

                    // Filtered Values
                    setValues(valuesArray);
                },
            });
        }
    };

    // 파일 Key값 체크
    function isKeyCheck(element) {
        if(element.asset_type != assetType) {
            return false;
        }
        return true;
    };

    // 저장
    const onClickSaveHandler = () => {
        // 필수조건 체크
        if (reportId == '' || resultType == '') {
            Modal.info({title:titleName, content:"Report Id, Result Type이 누락되었습니다."});
            return;
        }
        // if(!parsedData.find(isKeyCheck)) {
        //     Modal.error({title: "There is data that does not match the condition."});
        //     return;
        // }

        setUploading(true);
        setSpinflag(true);
        setIsDataChange(false);

        axios.post(postSaveResultUpload(), {
            reportId : reportId,
            resultType : resultType,
            parsedData : parsedData,
          }, {logCompany : companyCode, logParam : reportId})
          .then((response) => {
            setUploading(false);
            setSpinflag(false);

            if( response.data.status === "success"
                // response.data?.message == "취약점 분석 결과 수정 및 위험 평가 완료"
            ) {
                let nowMessage=[];
                let i=0;

                for(let objData of response.data.message.warnings){
                    if(objData.description){
                        nowMessage.push(objData);
                        ++i;
                    }
                }

                const nowContent=(
                    <>
                    <div style={{fontWeight:"bold", padding:"3px 0 5px 0"}}> 성공적으로 데이터가 입력되었습니다.</div>
                    <table className="rms-popup-border">
                        <tbody>
                        {nowMessage.map((message, index) => (
                            <>
                            <tr  style={{backgroundColor:"#ededed"}} key={`a${index}`}><td>{message["description"]}</td></tr>
                            {message["items"].map((asset, id) => (                  
                                <>             
                                <tr key={`b${index}-${id}`}><td>{asset}</td></tr>
                                </>
                            ))}
                            {/* <tr key="b{index}"><td>{message["items"].join()}</td></tr> */}
                            </>
                        ))}
                        </tbody>
                    </table>
                    </>
                );
                
                Modal.info({title: titleName, content:nowContent, okText:"Close", onOk() {
                    // 결과내용 재조회
                    setPageOnStart(true);
                    setIsDataChange(true);
                }});
            } else {
                let today = new Date();   
                // let message = "■ "+response.data.status;
                // if(response.data['IP가 다름'].length < 1 && response.data['Name이 다름'].length < 1 ){
                //     message = message +"\n템플릿이 다르거나 자산파일에 누락된 필드(자신이름, ip) 정보가 있는지 확인해 주세요";
                // }else{
                //     message = message + "\n● IP가 다른 자산\n"+(response.data['IP가 다름'] && response.data['IP가 다름'].length > 0 ?  JSON.stringify(response.data['IP가 다름']) : '없음');
                //     message = message + "\n● Name이 다른 자산\n"+(response.data['Name이 다름'] && response.data['Name이 다름'].length > 0 ?  JSON.stringify(response.data['Name이 다름']) : '없음');
                // }
                // message = message + "\n● 신규자산\n"+(response.data['새로운 자산'] && response.data['새로운 자산'].length > 0 ?  JSON.stringify(response.data['새로운 자산']) : '없음');

                // const Table = () => ( <table border="1"> <tr><td>7</td></tr> </table> );
                // setResMessage(<Table />);
                setResMessage(response.data.status.differences.sort((a, b) => { if (a.mismatch_type < b.mismatch_type) return -1;  if (a.mismatch_type > b.mismatch_type) return 1;  return 0; }));
            }
        })
        .catch((error) => {
            setUploading(false);
            setSpinflag(false);

            if(error.response.data.status == "warning"){
            
                let wariningMessage=[];

                for(let objData of error.response.data.warnings){
                    wariningMessage.push(objData);
                }                

                const warningContent=(
                    <>
                    <div style={{fontWeight:"bold", padding:"3px 0 5px 0"}}> {error.response.data.message}</div>
                    <table className="rms-popup-border">
                        <tbody>
                        <tr style={{backgroundColor:"#ededed"}}><td>No</td><td>내용</td></tr>
                        {wariningMessage.map((message, index) => (
                            <>
                            <tr key="a{index}"><td>{index+1}</td><td>{message}</td></tr>
                            </>
                        ))}
                        </tbody>
                    </table>
                    </>
                );
                Modal.error({title:"업로드 오류", content:warningContent, okText:"Close"});
            }else if(error.response.data.status == "fail" ){
                Modal.error({title:"업로드 오류", content:error.response.data.message, okText:"Close"});
            }else{
                Modal.error({title:titleName, content:error.message, okText:"Close"});
            }
        });
    
    };

    
    const onClickAnalysisHandler = (e) => { 
        console.log('[TIMING] 분석 요청 시작:', new Date());


        // 필수조건 체크
        if (!resultListData.length || resultListData.length == 0) {
            Modal.info({title:titleName, content:"결과를 먼저 등록하세요."});
            return;
        }

        // 진단결과 피일 값에서 SELF 체크
        //if(selfFlag){
        if(selfFlagRef.current){
            Modal.info({
                title: titleName, 
                content: ( <> 취약점진단 결과 값에 <span style={{color:'red',fontWeight:'bold'}}>'SELF'</span> 값이 있습니다.<br />'Y' 또는 'N'으로 결정하여 올려주시기 바랍니다. </>), 
                okText: "Close",
                width:450
              });            
            return;
        }

        setIsLoading(true);
        setIsDataChange(false);

        axios.post(postSaveResultAnalysis(), {
            reportId : reportId,
            resultType : resultType,
          }, {logCompany : companyCode, logParam : reportId})
          .then((response) => {

            if(response.data.status == "success") {    
                console.log('[TIMING] 서버 응답 받음:', new Date());
                console.log('[TIMING] session_id:', response.data.session_id);    
                
                e.preventDefault();
                e.stopPropagation();

                const sessionId = response.data.session_id; 
                // 팝업 window의 크기 지정
                const width = 700; 
                const height = 800; 

                // 팝업을 부모 브라우저의 정 중앙에 나열
                const left = window.screenX + (window.outerWidth - width) / 2;
                const top = window.screenY + (window.outerHeight - height) / 2;
                const windowOptions= `width=${width},height=${height},left=${left},top=${top}, scrollbars=no`;

                const popup = window.open(getProcessingPage(sessionId),"progress", windowOptions);
                // const popup = window.open("/a.html","progress", windowOptions);
                
                if (!popup || popup.closed || typeof popup.closed == 'undefined') {
                    // 팝업이 차단됨
                    Modal.warning({
                        title: titleName,
                        content: "팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요."
                    });
                    setIsLoading(false);
                    return;
                }

                popup.focus();

                if( popupCheckTimer ) {
                    clearInterval(popupCheckTimer);
                }
                
                // 폴링방식(새로운 타이머 시작)
                popupCheckTimer = setInterval(function() {
                    console.log("팝업 상태 확인 중...");
                    if (popup && popup.closed) {
                        setIsDataChange(true); // data 새로고침 필요
                        setIsLoading(false);
                        clearInterval(popupCheckTimer);
                        popupCheckTimer = null;
                    }
                }, 1000);
                
                // setIsLoading(false);
                // 팝업창에서 보낸 데이터 부모창에서 확인하는 로직
                // 상단 코드로 대처 (폴링 방식 사용)
                window.addEventListener('message', function(event) {
                    if (event.data.type === 'closePopup') {
                        setIsDataChange(true); // data 새로고침 필요
                        setIsLoading(false);
                        clearInterval(popupCheckTimer);
                        popupCheckTimer = null;
                    }
                });

            }else{
                // 실패 처리
                setIsLoading(false);
                Modal.error({
                    title: titleName,
                    content: response.data.message || "분석 시작에 실패했습니다."
                });
            }
        })
        .catch((error) => {
            setIsLoading(false);
            
            // 서버 응답 메시지 처리
            let errorMessage = "네트워크 오류가 발생했습니다.";
            
            if (error.response) {
                // 서버가 응답한 경우
                if (error.response.data) {
                    if (typeof error.response.data === 'string') {
                        errorMessage = error.response.data;
                    } else if (error.response.data.message) {
                        errorMessage = error.response.data.message;
                    } else if (error.response.data.error) {
                        errorMessage = error.response.data.error;
                    } else if (error.response.data.detail) {
                        errorMessage = error.response.data.detail;
                    }
                }
            } else if (error.message) {
                // 네트워크 오류 등
                errorMessage = error.message;
            }
            
            Modal.error({
                title: "결과 분석 실패",
                content: errorMessage,
                okText: "Close",
                width: 600
            });
        });
    }

    // 결과분석
    const onClickAnalysisHandler_999999 = () => {

        // 필수조건 체크
        if (!resultListData.length || resultListData.length == 0) {
            Modal.info({title:titleName, content:"결과를 먼저 등록하세요."});
            return;
        }

        // 진단결과 피일 값에서 SELF 체크
        //if(selfFlag){
        if(selfFlagRef.current){
            Modal.info({
                title: titleName, 
                content: ( <> 취약점진단 결과 값에 <span style={{color:'red',fontWeight:'bold'}}>'SELF'</span> 값이 있습니다.<br />'Y' 또는 'N'으로 결정하여 올려주시기 바랍니다. </>), 
                okText: "Close",
                width:450
              });            
            return;
        }

        setIsLoading(true);
        setIsDataChange(false);
        axios.post(postSaveResultAnalysis(), {
            reportId : reportId,
            resultType : resultType,
          }, {logCompany : companyCode, logParam : reportId})
          .then((response) => {
            setIsLoading(false);

            if(response.data.status == "success") {
                let message = '';
                let nowMessage=[];
                let i=0;
                
                if(resultType == 'U') {
                    message = '※ 이행진단의 결과가 등록되지 않은 자산은 초기진단 결과로 분석됩니다.'
                }

                for(let objData of response.data?.message.warnings){
                   
                    if(objData.description){
                   
                        if(objData.description =="일부 자산 정보가 DB에 없는데 분석되었습니다."){
                            objData.description = (<p>자산에는 없고 진단 결과에만 포함되어 있음<br/>(자산:X 파일:O)</p>);
                        }else if(objData.description == "DB에 있는 자산에 대한 분석이 누락되었습니다."){
                            objData.description = (<p>자산에 있지만 진단 결과에 포함되어 있지 않음<br/>(자산:O 파일:X)</p>);
                        }

                        nowMessage.push(objData);
                        ++i;
                    }
                }


                const nowContent=(
                    <>
                    <div style={{fontWeight:"bold", padding:"3px 0 5px 0"}}> 성공적으로 데이터가 분석되었습니다.</div>
                    <div style={{fontWeight:"bold", color:"blue"}}> {message}</div>
                    {nowMessage.length >0 ? <div style={{fontWeight:"bold", padding:"2px 0 5px 0"}}>아래 표에 있는 누락자산은 분석 되지 않았습니다.</div>:"" }
                    <table className="rms-popup-border" width="100%">
                        <tbody>
                        {nowMessage?.map((message, index) => (
                            <>
                            <tr style={{backgroundColor:"#ededed"}} key="a{index}"><td colspan={2}>{message["description"]}</td></tr>
                            <tr key="b{index}"><td>누락자산</td><td style={{wordBreak: "break-all", overflowWrap: "break-word"}}><p>{message["assets"] ? message["assets"].join():'없음'}</p></td></tr>
                            </>
                        ))}
                        </tbody>
                    </table>                    
                    </>
                );

                Modal.info({title: "결과 분석 성공", content:nowContent, okText:"Close", onOk() {
                    // 결과내용 재조회
                    setIsDataChange(true);
                    setResultCd('');
                }});
            } else {
                Modal.info({title: "결과 분석 실패", content:response.data, okText:"Close"});  
            }
        })
        .catch((error) => {
            setIsLoading(false);
            
            // 서버 응답 메시지 처리
            let errorMessage = "네트워크 오류";
            
            if (error.response) {
                // 서버가 응답한 경우
                if (error.response.data) {
                    if (typeof error.response.data === 'string') {
                        errorMessage = error.response.data;
                    } else if (error.response.data.message) {
                        errorMessage = error.response.data.message;
                    } else if (error.response.data.error) {
                        errorMessage = error.response.data.error;
                    } else if (error.response.data.detail) {
                        errorMessage = error.response.data.detail;
                    }
                }
            } else if (error.message) {
                // 네트워크 오류 등
                errorMessage = error.message;
            }
            
            Modal.error({
                title: "결과 분석 실패",
                content: errorMessage,
                okText: "Close",
                width: 600
            });
        });
    
    };
    // (수정)저장 클릭 시
    const onClickModifyHandler = (saveData) => {
        // 변경건이 있으면 추가
        const currentPageModified = resultListData.filter(item => item.operation);
        if(currentPageModified.length > 0) {
            saveModifyVaResultData(currentPageModified);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }

        // 추가, 삭제같은 기능이 있다면 AnalysisTable.js 파일에서 전달하는 saveData필요
        // if(saveData.length > 0) {
        //     saveModifyVaResultData(saveData);
        // } else {
        //     Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        // }
    }

    // 진단결과 수정 API (메시지 없이 자동 저장용)
    const saveModifyVaResultDataSilent = (saveData) => {
        axios.post(postModifyVaResultData()
            , {reportId : reportId, resultType : resultType, saveData : saveData}
            , {logCompany : companyCode, logParam : reportId})
            .then((response) => {
                console.log('자동 저장 완료');
            })
            .catch((error) => {
                console.error('자동 저장 실패:', error);
            });
    }

    // 진단결과 수정 API
    const saveModifyVaResultData = (saveData) => {
        setIsDataChange(false);
        // try{
        //     const req = await axios.post(postModifyVaResultData()
        //     , {reportId : reportId, resultType : resultType, saveData : saveData}
        //     , {logCompany : companyCode, logParam : reportId});

        //     if(req.data.message == '취약점 분석 결과 수정 및 위험 평가 완료') {
        //         Modal.confirm({title: "진단결과가 변경되어 [결과분석]을 재실행해야 합니다.", 
        //                         content: "바로 [결과분석]을 실행하시겠습니까?",
        //                         okText:"Yes", cancelText:"No",
        //                         onOk : onClickAnalysisHandler,
        //                         onCancel : setIsDataChange(true)
        //                 });
        //     } else {
        //         Modal.info({title: response.data.message+"--", okText:"Close"});  
        //     }
        // }catch(error){
        //     console.log("AnalysisResult.js --- 371 error");
        //     Modal.info({title: "Error.", okText:"Close"});
        // }

        axios.post(postModifyVaResultData()
                        , {reportId : reportId, resultType : resultType, saveData : saveData}
                        , {logCompany : companyCode, logParam : reportId})
        .then((response) => {
            // if(response.data.status == 'success') {
            if(response.data.status == 'success') {
                // setResultListData(prevData => {
                //     return [...prevData, ...saveData];
                // });
                Modal.info({title: "진단결과가 수정되었습니다.", okText:"Close", onOk : () => {
                    setIsDataChange(true);
                }});  
                
                // Modal.confirm({title: "진단결과가 변경되어 [결과분석]을 재실행해야 합니다.....", 
                //                 content: "바로 [결과분석]을 실행하시겠습니까?",
                //                 okText: "Yes", 
                //                 cancelText: "No",
                //                 onOk : onClickAnalysisHandler,
                //                 // onOk: () => {
                //                 //     findAnalysisResultList(); // 데이터 재조회
                //                 //     onClickAnalysisHandler(); // 분석 실행
                //                 // },
                //                 // onCancel: close
                //                 // onOk : onClickAnalysisHandler,
                //                 // onCancel : setIsDataChange(true)
                //         });
            } else {
                Modal.info({title: response.data.message, okText:"Close"});  
            }
        })
        .catch((error) => {
            Modal.error({title: "Error.", okText:"Close"});
        });
    };

    useEffect(() => {
            findAnalysisInfo(1);
            // setPageSize(assetPageSize);
            // templateColumn();
    }, []);
    
    // self값 조회 
    useEffect(() =>{

        let resultListDataCount = resultListData.length;
        const keyRegex = /.*SELF/i;

        selfFlagRef.current = false;
        for(let i = 0; i < resultListDataCount; i++) {
            if(keyRegex.test(resultListData[i]["result_cd"])) {
                selfFlagRef.current = true;
                break;
            }
        }

    }, [resultListData]);

    // 정보 변경시 재조회
    // useEffect(() => {
    //     if(isDataChange) { findAnalysisResultList(1, pageSize); }
    // }, [isDataChange]);    

    // 결과 조회
    // useEffect(() => {
    //     console.log("930");
    //     findAnalysisResultList(1, pageSize);
    //     // templateColumn();
    // }, [reportId, isDataChange]);
    // 진단결과 선택 시 자동 조회

    // useEffect(() => {
    //     if (resultCd !== undefined && resultCd !== null && reportId) {
    //         findAnalysisResultList(1, pageSize);
    //     }
    // }, [resultCd]);

    // 진단결과 선택 시 자동 조회
    useEffect(() => {
        if (resultCd !== undefined && resultCd !== null && reportId) {
            findAnalysisResultList(1, pageSize);
        }
    }, [reportId, isDataChange, resultCd]);
    
    // 데이터가 준비되면 다운로드 실행
    useEffect(() => {
        if (csvReadyDownload && csvLinkRef.current) {
        csvLinkRef.current.link.click();
        setCsvReadyDownload(false); // 플래그 초기화
        }
    }, [csvReadyDownload]);


    useEffect(() => {
        if(resMessage) {  
            const csvData = resMessage.flatMap((dataSrc) => {
                
                if (Object.keys(dataSrc).length > 4) {
                    if(dataSrc["json_name"] && dataSrc["db_name"] && dataSrc["asset_cd"]){
                        return [
                            {
                                asset_cd: dataSrc["asset_cd"],
                                mismatch_type: dataSrc["mismatch_type"],
                                asset_nm: dataSrc["json_name"],
                                asset_ip: dataSrc["json_ip"] ? dataSrc["json_ip"]:dataSrc["db_ip"]

                            },
                            {
                                asset_cd: "",
                                mismatch_type: "",
                                asset_nm: dataSrc["db_name"],
                                asset_ip: ""
                            }
                        ];
                    }else if(dataSrc["json_name"] && dataSrc["db_name"] && dataSrc["db_asset_cd"]){
                        return [
                            {
                                asset_cd: dataSrc["db_asset_cd"],
                                mismatch_type: dataSrc["mismatch_type"],
                                asset_nm: dataSrc["json_name"],
                                asset_ip: dataSrc["asset_ip"] ? dataSrc["asset_ip"]:dataSrc["db_ip"]

                            },
                            {
                                asset_cd: "",
                                mismatch_type: "",
                                asset_nm: dataSrc["db_name"],
                                asset_ip: ""
                            }
                        ];
                    }else if(dataSrc["mismatch_type"] == "ip_mismatch_for_name"){
                        return [
                            {
                                asset_cd: dataSrc["db_asset_cd"],
                                mismatch_type: dataSrc["mismatch_type"],
                                asset_nm: dataSrc["asset_name"],
                                asset_ip: dataSrc["json_ip"] ? dataSrc["json_ip"]:dataSrc["db_ip"]

                            },
                            {
                                asset_cd: "",
                                mismatch_type: "",
                                asset_nm: dataSrc["db_name"],
                                asset_ip: ""
                            }
                        ];
                    }else{
                        return [
                            {
                                asset_cd: dataSrc["db_asset_cd"],
                                mismatch_type: dataSrc["mismatch_type"],
                                asset_nm: dataSrc["json_name"] ? dataSrc["json_name"]:dataSrc["db_name"],
                                asset_ip: dataSrc["json_ip"]

                            },
                            {
                                asset_cd: "",
                                mismatch_type: "",
                                asset_nm: "",
                                asset_ip: dataSrc["db_ip"]
                            }
                        ];
                    }

                } else {
                    // 신규자산으로 인식 할 때
                    return {
                        asset_cd: dataSrc["asset_cd"],
                        mismatch_type: dataSrc["mismatch_type"],
                        asset_nm: dataSrc["asset_nm"],
                        asset_ip: dataSrc["asset_ip"]
                    };
                }
            });
            
            Modal.info({
              title: "자산 등록 오류", 
              content: ( <>
                <table className="rms-popup-border" width="100%">
                    <tbody>
                    <tr style={{backgroundColor:"#ededed"}}><td>자산코드</td><td>현황</td><td>자산이름</td><td>IP</td></tr>
                    { resMessage.map((dataSrc, index) => (
                        <React.Fragment key={index}>                    
                            { (Object.keys(dataSrc).length > 4) ? (
                                    (dataSrc["db_name"] && dataSrc["json_name"] && dataSrc["asset_cd"])) ? (
                                        <>
                                        <tr><td rowSpan={2}>{dataSrc["asset_cd"]}</td><td rowSpan={2}>{dataSrc["mismatch_type"]}</td><td>{dataSrc["json_name"]}</td><td rowSpan={2}>{dataSrc["json_ip"] ? dataSrc["json_ip"] : dataSrc["db_ip"]}</td></tr> 
                                        <tr><td>{dataSrc["db_name"]}</td></tr>
                                        </>
                                    ):((dataSrc["db_name"] && dataSrc["json_name"] && dataSrc["db_asset_cd"]) ? (
                                        <>
                                        <tr><td rowSpan={2}>{dataSrc["db_asset_cd"]}</td><td rowSpan={2}>{dataSrc["mismatch_type"]}</td><td>{dataSrc["json_name"]}</td><td rowSpan={2}>{dataSrc["asset_ip"] ? dataSrc["asset_ip"] : dataSrc["db_ip"]}</td></tr> 
                                        <tr><td>{dataSrc["db_name"]}</td></tr>
                                        </>
                                    ):(dataSrc["mismatch_type"] == "ip_mismatch_for_name") ? (
                                        <>
                                        <tr><td rowSpan={2}>{dataSrc["db_asset_cd"]}</td><td rowSpan={2}>{dataSrc["mismatch_type"]}</td><td rowSpan={2}>{dataSrc["asset_name"] ? dataSrc["asset_name"] : dataSrc["db_name"]}</td><td>{dataSrc["json_ip"]}</td></tr> 
                                        <tr><td>{dataSrc["db_ip"]}</td></tr>
                                        </>
                                    ):
                                    (
                                        <>
                                        <tr><td rowSpan={2}>{dataSrc["asset_cd"]}</td><td rowSpan={2}>{dataSrc["mismatch_type"]}</td><td rowSpan={2}>{dataSrc["json_name"] ? dataSrc["json_name"]:dataSrc["db_name"]}</td><td>{dataSrc["json_ip"]}</td></tr> 
                                        <tr><td>{dataSrc["db_ip"]}</td></tr>
                                        </>
                                    )
                                ):(
                                    <>
                                    <tr><td>{dataSrc["asset_cd"]}</td><td>{dataSrc["mismatch_type"]}</td><td>{dataSrc["asset_nm"]}</td><td>{dataSrc["asset_ip"]}</td></tr>
                                    </>
                                )
                            }
                        </React.Fragment>
                    )) } 
                    </tbody>
                </table> 
                {/* <CSVLink
                    data={csvData}
                    headers={csvHeaders}
                    filename={"error_message.csv"}
                >
                    <button style={{ position: "absolute", bottom: "20px" }}>다운로드</button>
                </CSVLink> */}
                <Button onClick={() => downloadExcel(csvData, "error_message")} style={{ position: "absolute", bottom: "20px", padding: "0px 5px 10px 5px" }}>
                    엑셀다운로드
                </Button>
                </>
                ), 
            // content: ( <>
            //         { resMessage.split('\n').map((line, index) => (
            //         <React.Fragment key={index}>
            //             {index === 0 ? <b>{line}</b> : 
            //             /^● /.test(line) ? <b>{line}</b> : line }<p />
            //         </React.Fragment>
            //         )) } 
            //         </>
            //     ), 
              okText: "Close",
              width:620
            });
            setResMessage("");
          }
    }, [resMessage]);

    useWindowCloseMsg(resultListData);
    
    const csvHeaders = [
        { label: "자산코드", key: "asset_cd" },
        { label: "현황", key: "mismatch_type" },
        { label: "자산이름", key: "asset_nm" },
        { label: "IP", key: "asset_ip" }
    ];

    const downloadExcel = (data, filename) => {

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.utils.sheet_add_aoa(worksheet, [["자산코드", "현황", "자산이름", "IP"]], { origin: "A1" });
        
        // Merge cells for rowspan
        const merges = [];
        let currentRow = 1;
        data.forEach((row, index) => {
            if (!row.mismatch_type || row.mismatch_type === "") {
                merges.push({ s: { r: currentRow-1, c: 0 }, e: { r: currentRow, c: 0 } });
                merges.push({ s: { r: currentRow-1, c: 1 }, e: { r: currentRow, c: 1 } });
                // if(row.json_ip && row.db_ip){
                //     merges.push({ s: { r: currentRow-1, c: 2 }, e: { r: currentRow, c: 2 } });
                // }else if(row.json_name && row.db_name){
                //     merges.push({ s: { r: currentRow-1, c: 3 }, e: { r: currentRow, c: 3 } });
                // }
                currentRow += 1;
            } else {
                currentRow++;
            }
        });

        worksheet['!merges'] = merges;   
        XLSX.writeFile(workbook, `${filename}.xlsx`);
    };

    // 닫기
    const onClickCloseHandler = () => {
        window.close();
        // onClose?.(true);
    }

    // 조회
    const onClickSearchCdHandler = () => {
        // 선택된 조건에 대하여 조회
        findAnalysisResultList(1, pageSize);
    }

    const onClickDeleteHandler = () => {
        if(reportId){
            
            setDataDeleting(true);
            setSpinflag(true);

            axios.post(postAnalysisDelete(), {reportId : reportId}).then((response) => {
                // if(response.data.status == 'success') {
                setIsDataChange(true);

                if(response.data === "보고서 삭제가 완료되었습니다.") {
                    Modal.info({title:titleName, content:"리포트가 삭제 되었습니다", okText:"Close"});
                } else {
                    Modal.info({title:titleName, content:response.data.message, okText:"Close"});  
                }
            }).catch((error) => {
                Modal.error({title:titleName, content:error.message, okText:"Close"});
            }).finally(()=>{
                setDataDeleting(false);
                setSpinflag(false);
            });
        }
    }

    //수동진단 리포트 upload파일 데이터 self로 자동생성
    const onClickAutoSelfReport = () => {
        // 필수조건 체크
        if (reportId == '' ) {
            Modal.info({title:titleName, content:"Report Id가 누락되었습니다."});
            return;
        }

        setUploading(true);
        setSpinflag(true);
        setIsDataChange(false);
        
        axios.post(postSaveResultAutoSelf(reportId), {
            reportId : reportId,
            resultType : resultType,
          }, '').then((response) => {
            setUploading(false);
            setSpinflag(false);
            
            if( response.data.status === "success"
                // response.data?.message == "취약점 분석 결과 수정 및 위험 평가 완료"
            ) {
                setSelfAutoFlag(true);
                const nowContent=(
                    <>
                    <div style={{fontWeight:"bold", padding:"3px 0 5px 0"}}> 성공적으로 {response.data.message} </div>
                    </>
                );

                Modal.info({title: titleName, content:nowContent, okText:"Close", onOk() {
                    // 결과내용 재조회
                    setIsDataChange(true);
                }});
            } else {
                let today = new Date();   
                setResMessage(response.data.status.differences.sort((a, b) => { if (a.mismatch_type < b.mismatch_type) return -1;  if (a.mismatch_type > b.mismatch_type) return 1;  return 0; }));
            }
        }).catch((error) => {
            setUploading(false);
            setSpinflag(false);
            Modal.error({title:titleName, content:error.message, okText:"Close"});
        });
   
    }

    const onClickRefDetail = () => {
        const url = '#/analysis/resultpop/ref/'+reportId+'/'+resultListAssetcd;
        const target = 'analysisRefDetail';
        const option_fix = getPopupSizeOption('1200', '900', 'fix');
        window.open(url, target, option_fix);        
    }

    const onPageChange = (newPage, newPageSize) => {
            // 현재 페이지의 수정된 데이터 확인
            const currentPageModified = resultListData.filter(item => item.operation);
            
            // 수정된 데이터가 있으면 자동 저장
            if (currentPageModified.length > 0) {
                console.log('페이지 이동 시 자동 저장:', currentPageModified.length + '건');
                // 자동 저장 실행 (메시지 표시 없이)
                saveModifyVaResultDataSilent(currentPageModified);
            }
            
            setPage(newPage);
            if (newPageSize !== pageSize) {
                setPage(1);
                setPageSize(newPageSize);
            }
            
            // 잠시 대기 후 다음 페이지 로드 (저장 완료 대기)
            setTimeout(() => {
                findAnalysisResultList(newPage, newPageSize);
            }, 300);
    };

    //----------------------------------------------------------------------------------------
    return (
        <Spin size={"large"}  tip={loadMessage} spinning={spinflagMain}>
        <Layout id="report" style={{overflow: 'hidden'}}>
            <div className='popup_header'>
                <div className='popup_title'>
                    {titleName} : 취약점분석 결과
                </div>
            </div>
            <div className="popup_button" style={{top:'10px'}}>
                {confirmed && (
                    <span style={{color : '#ff0000', fontSize: '11px', marginRight: '10px'}}>확정된 보고서로 진단결과 수정이 불가합니다.</span>
                )}
                {!confirmed && (
                    <Button
                            type="default"
                            onClick={onClickAutoSelfReport}
                            loading={uploading}
                            disabled={selfAutoFlag}
                            style={{marginRight: '10px', border:'0px'}}
                        >
                            {'수동진단 자동생성'}
                        </Button>
                )}
                <Button
                        type="default"
                        onClick={onClickRefDetail}
                        loading={uploading}
                        style={{marginRight: '10px'}}
                    >
                        {'REF 상세정보'}
                    </Button>
                <CSVLink
                    data={csvData}
                    headers={csvHeader}
                    // data={csv_data}
                    // headers={csv_headers}
                    filename={'결과분석_업로드양식'}
                    style={{display: "none"}}
                    ref={csvLinkRef}
                    target="_blank"
                />
                <Button
                    type="default"
                    style={{marginRight: '10px'}}
                    loading={csvDownLoading}
                    onClick={templateColumn}
                > 샘플 다운
                </Button>
                <Button
                    type="default"
                    style={{marginRight: '10px'}}
                    loading={detailReportLoading}
                    disabled={(resultListData.length && resultListData.length > 0) ? false : true}
                    onClick={onClickDetailReportHandler}
                > 상세결과 보고서
                </Button>
                {!confirmed && (
                    <>
                        <input
                            type="file"
                            name="file"
                            className='ant-btn-primary'
                            style={{padding: '4px 15px'}}
                            onChange={onChangeUploadHandler}
                            accept=".csv, .txt"
                        />
                        {showUpload? (
                            <Button
                                type="primary"
                                onClick={onClickSaveHandler}
                                loading={uploading}
                                disabled={(tableRows.length && tableRows.length > 0) ? false : true}
                                style={{marginRight: '10px'}}
                            >
                                {'저장'}
                            </Button>
                            ) : (
                                <></>
                        )}
                        <Button
                            type="primary"
                            onClick={onClickAnalysisHandler}
                            loading={isLoading}
                            disabled={(resultListData.length && resultListData.length > 0) ? false : true}
                            style={{marginRight: '10px'}}
                        >
                            {'결과분석'}
                        </Button>
                        {resultType == 'C' ? (
                            <Button
                                type="primary"
                                onClick={onClickDeleteHandler}
                                loading={dataDeleting}
                                disabled={(resultListData.length && resultListData.length > 0) ? false : true}
                                style={{marginRight: '10px'}}
                            >
                                    {'결과분석 삭제'}
                            </Button>
                        ) : (
                            <Button
                                type="primary"
                                onClick={onClickDeleteHandler}
                                loading={dataDeleting}
                                disabled={(resultListData.length && resultListData.length > 0) ? false : true}
                                style={{marginRight: '10px'}}
                            >
                                    {'결과분석 삭제'}
                            </Button>
                        )}
                    </>
                )}
                <Button
                    type="default"
                    onClick={onClickCloseHandler}
                    style={{marginLeft: '10px'}}
                >
                    {'닫기'}
                </Button>
            </div>
            <div className="section">
                <table className='search'>
                    <colgroup>
                        <col style={{width:'10%'}} />
                        <col style={{width:'12%'}} />
                        <col style={{width:'10%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'10%'}} />
                        <col style={{width:'12%'}} />
                        <col style={{width:'10%'}} />
                        <col style={{width:'18%'}} />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th>자산구분</th>
                        <td>{assetType}</td>
                        <th>취약점분석명</th>
                        <td>{reportName}</td>
                        <th><span className='req'>*</span>취약점분석ID</th>
                        <td>{reportId}</td>
                        <th><span className='req'>*</span>결과유형</th>
                        <td>{titleName}
                            {/* <!-- Radio.Group id={resultType} disabled={true} value={resultType}>
                                <Radio value={'C'}>최초분석</Radio>
                                <Radio value={'U'}>이행점검</Radio>
                            </Radio.Group --> */}
                        </td>
                    </tr>
                    {!showUpload? (
                          <tr>
                            <th>자산코드</th>
                            <td><Input id="assetCd" size="small"
                                   allowClear
                                   value={assetCd}
                                   onChange={(event) => {setAssetCd(event.target.value)}}
                                /></td>
                            <th>진단코드</th>
                            <td><Input id="measureCd" size="small"
                                   allowClear
                                   value={measureCd}
                                   onChange={(event) => {setMeasureCd(event.target.value)}}
                                /></td>
                            <th>진단결과</th>
                            <td colSpan={3}>
                                <SelectBox 
                                    tag='resultCd' 
                                    options={analySelectOptions} 
                                    value={resultCd}  
                                    onChangeHandler={(value) => {
                                        setResultCd(value);
                                    }} 
                                    widthValue="170px" />
                                <Button
                                    type="primary"
                                    onClick={onClickSearchCdHandler}
                                    style={{marginLeft: '10px',width:'70px'}}
                                >
                                {'조회'}
                            </Button>
                            </td>
                        </tr>
                    ) : (  
                        <>
                        </>
                    )}
                    </tbody>
                </table>
            </div>
            {showUpload ? (
                <div className="section" id="uploadTable">      
                    <Content style={{ height: 450, backgroundColor: '#fff', overflow: 'scroll'}}>
                        <table>
                            <thead>
                            <tr>
                                {tableRows.map((rows, index) => {
                                return <th key={index}>{rows}</th>;
                                })}
                            </tr>
                            </thead>
                            <tbody>
                            {values.map((value, index) => {
                                return (
                                <tr key={index}>
                                    {value.map((val, i) => {
                                        return <td key={i}>{val}</td>;
                                    })}
                                </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </Content>
                </div>
            ) : (
                <div className="section" id="resultTable">
                    <AnalysisTable
                        data={resultListData} 
                        columnData={resultColumnData}
                        reportId={reportId}
                        reportInfo={reportInfo}
                        isLoading={isLoading} 
                        onClickSaveHandler={onClickModifyHandler}
                        rowSelection={rowSelection}
                        selectedRowKeys={selectedRowKeys}
                        spinflag={spinflag}
                        onDataChange={(modifiedData) => {
                            // 데이터 변경 시 resultListData 업데이트
                            setResultListData(modifiedData);
                        }}
                        pagination={{
                            current:page, 
                            pageSize:pageSize, 
                            total:totalCount, 
                            position: ['bottomCenter'],
                            onChange: onPageChange,           // 페이지 변경 핸들러 추가
                            onShowSizeChange: onPageChange,  // 페이지 크기 변경 핸들러 추가
                            showSizeChanger: true,               // 페이지 크기 선택기 표시
                            // showQuickJumper: true,               // 페이지 번호 직접 입력
                            showTotal: (total, range) => 
                                `${range[0]}-${range[1]} of ${total} items`, 
                            pageSizeOptions: basePageSizeOptions
                        }}
                        // onChangeHandler= {onPageChange}
                    />
                </div>
            )}
        </Layout>
    </Spin>
    );
}

export default AnalysisResultPop;